import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import styles from './PublicSiteHeader.module.css';

/**
 * Shared sticky header for public legal pages (Terms, Privacy).
 */
export default function PublicSiteHeader({ linkLogoToHome = false, onLogin, onSignup }) {
  const navigate = useNavigate();

  const handleLogin = () => {
    if (onLogin) {
      onLogin();
    } else {
      navigate('/login');
    }
  };

  const handleSignup = () => {
    if (onSignup) {
      onSignup();
    } else {
      navigate('/signup');
    }
  };

  const brand = (
    <div className={styles.logoSection}>
      <BrandLogo alt="Richuel Logo" decorative={linkLogoToHome} imgClassName={styles.headerLogoImg} />
      <span className={styles.logoText} {...(linkLogoToHome ? { 'aria-hidden': true } : {})}>
        Richuel
      </span>
    </div>
  );

  return (
    <header className={styles.header} role="banner">
      <div className={styles.headerInner}>
        {linkLogoToHome ? (
          <Link to="/" className={styles.headerLogoLink} aria-label="Richuel home">
            {brand}
          </Link>
        ) : (
          brand
        )}
        <nav className={styles.headerNav} aria-label="Account actions">
          <button
            type="button"
            className={styles.headerLoginButton}
            onClick={handleLogin}
            aria-label="Log in to your account"
          >
            Log in
          </button>
          <button
            type="button"
            className={styles.headerSignupButton}
            onClick={handleSignup}
            aria-label="Sign up for an account"
          >
            Sign up
          </button>
        </nav>
      </div>
    </header>
  );
}
